(function($) {
    $('body').on('action:changed', function(event, data) {
        var data = data.data;
        console.log(data);
        // set monthly
        $('.action__monthly-normal-discount').text(
            data.action.strings.monthly_normal
        );

        $('.action__monthly-fast-discount').text(
            data.action.strings.monthly_fast
        );

        // set pk
        $('.action__pk-discount').text(
            data.action.strings.pk
        );


        if (data.action.bonus) {
            // set image
            $('.action__floating-image img')
                .attr('src', '/assets/static/img/actions/gifts/' + data.action.bonus.image);

            if (data.action.bonus.monthly_page) {
                $('.action__bonus-item--monthly')
                    .removeClass('action__bonus-item--hidden')
                    .find('.action__bonus-monthly-name')
                    .text(data.action.bonus.monthly_page);
            }

            if (data.action.bonus.pk_page) {
                $('.action__bonus-item--pk')
                    .removeClass('action__bonus-item--hidden')
                    .find('.action__bonus-pk-name')
                    .text(data.action.bonus.pk_page);
            }
        }
    });
})(jQuery);
